"use client"

import { useState } from "react"
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline"
import { Tag } from "./Tag"

interface TagSectionProps {
  tags: string[] | undefined
  className?: string
  compact?: boolean
  maxVisible?: number
}

export function TagSection({
  tags,
  className = "",
  compact = false,
  maxVisible = 6,
}: TagSectionProps) {
  const [showAll, setShowAll] = useState(false)

  if (!tags || tags.length === 0) {
    return null
  }

  const shouldShowToggle = tags.length > maxVisible
  const visibleTags =
    shouldShowToggle && !showAll ? tags.slice(0, maxVisible) : tags
  const hiddenCount = tags.length - maxVisible

  return (
    <div className={`${className}`}>
      <div className="flex flex-wrap gap-2">
        {visibleTags
          .filter(tag => tag != null && tag !== "")
          .map(tag => (
            <Tag
              key={tag}
              tag={tag}
              compact={compact}
              className="mr-0 mb-0"
            />
          ))}
      </div>

      {shouldShowToggle && (
        <button
          type="button"
          onClick={() => setShowAll(!showAll)}
          className="mt-2 flex items-center text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
        >
          {showAll ? (
            <>
              <ChevronUpIcon className="mr-1 h-4 w-4" />
              Show less
            </>
          ) : (
            <>
              <ChevronDownIcon className="mr-1 h-4 w-4" />
              Show {hiddenCount} more {hiddenCount === 1 ? "tag" : "tags"}
            </>
          )}
        </button>
      )}
    </div>
  )
}
